import { Location } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  template: `
    <div class="w-full max-w-[90rem] items-center">
      <section class="mt- mb-8 flex lg:mb-0">
        <div
          class="w-full max-w-xl rounded-xl bg-white p-8 text-black shadow-lg md:p-10"
        >
          <!-- Comcast Business | Nitel Logo -->
          <div class="mb-4 flex md:justify-center">
            <a routerLink="/" class="inline-block" title="Go to homepage">
              <img
                src="assets/images/logos/CB_Logo_Color_RGB.svg"
                alt="Comcast Business"
                class="h-10 w-auto md:h-14"
              />
            </a>
          </div>
          <h2
            class="font-montserrat mt-4 text-2xl font-bold text-black lg:text-3xl"
          >
            Page Not Found
          </h2>
          <p class="mt-4 text-lg">This is not the page you were looking for!</p>
          <div class="mt-6 flex">
            <button
              type="button"
              (click)="goBack()"
              title="Go back"
              class="btn-primary"
            >
              Go back
            </button>
          </div>
        </div>
      </section>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PageNotFoundComponent {
  private location = inject(Location);

  goBack(): void {
    this.location.back();
  }
}
